import { Warning } from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import React from "react";

export function WouldNotExecuteUnderConditionsWarning(
    props: React.ComponentPropsWithoutRef<typeof Warning>,
) {
    return (
        <Tooltip title="This model would not normally run on this conversation due to execute conditions.">
            <Warning color="warning" fontSize="small" {...props} />
        </Tooltip>
    );
}
